<template>
    <v-container style="padding-top: 85px">
        <div>
            <v-layout row wrap>
                <v-flex xs12 sm12 md3>
                    <Telefonos @chatSeleccionado="ChatSeleccionadoEmit($event)" />
                </v-flex>
                <v-flex xs12 sm12 md9>
                    <v-container class="container-chat">
                        <v-dialog transition="dialog-top-transition" content-class="dialog-reporte" v-model="dialog"
                            persistent>
                            <template>
                                <v-card>
                                    <v-card-title class="justify-center primary">
                                        <v-toolbar-title id="titulocard">Clasificar Mensajes</v-toolbar-title>
                                    </v-card-title>
                                    <v-progress-linear color="green accent-4" indeterminate rounded height="6"
                                        v-if="cargar"></v-progress-linear>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" md="6" offset-md="3">
                                                <span style="
                                                        color: black;
                                                        text-align: center;
                                                        font-weight: bold;
                                                    ">Número de Reporte:
                                                </span>
                                                <multiselect v-model="Reportes.nrreporte"
                                                    deselect-label="No se puede remover el valor seleccionado"
                                                    selected-label="Seleccionado" select-label="Seleccione el reporte"
                                                    track-by="nrreporte" label="Reporte"
                                                    placeholder="Seleccione una opción"
                                                    :options="Reportes.opcionesReportes" :allow-empty="false"
                                                    :max-height="150">
                                                </multiselect>
                                                <span v-if="validareporte" class="spanError"
                                                    style="color: red; font-size: 11px">Campo requerido</span>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="6" offset-md="3">
                                                <span style="
                                                    color: black;
                                                    text-align: center;
                                                    font-weight: bold;
                                                ">
                                                    Número de mensajes seleccionados:
                                                </span>
                                            </v-col>
                                            <v-col cols="12" md="6" offset-md="3"
                                                style="justify-content: center; display: flex">
                                                <span style="
                                                        color: #1e88e5;
                                                        text-align: center;
                                                        font-size: xx-large;
                                                    " class="mt-2">
                                                    {{
                                                        this.$store.getters.getChecklistmensajes.length
                                                    }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions class="justify-center">
                                        <v-btn variant="text" color="#536DFE" style="color: white"
                                            @click="ClasificarMensajes()" :disabled="botonescarga">Guardar</v-btn>
                                        <v-btn variant="text" @click="dialog = false" color="default"
                                            :disabled="botonescarga">Cerrar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </template>
                        </v-dialog>

                        <v-dialog transition="dialog-top-transition" content-class="dialog-reporte"
                            v-model="dialogTemplates" persistent>
                            <template>
                                <v-card>
                                    <v-card-title class="justify-center primary">
                                        <v-toolbar-title id="titulocard">Enviar Template</v-toolbar-title>
                                    </v-card-title>
                                    <v-progress-linear color="green accent-4" indeterminate rounded height="6"
                                        v-if="cargarTemplate"></v-progress-linear>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" md="6" offset-md="3">
                                                <span style="
                            color: black;
                            text-align: center;
                            font-weight: bold;
                          ">Nombre Template:</span>
                                                <multiselect v-model="Templates.ntclave"
                                                    deselect-label="No se puede remover el valor seleccionado"
                                                    selected-label="Seleccionado" select-label="Seleccione el reporte"
                                                    track-by="ntclave" label="ntproceso"
                                                    placeholder="Seleccione una opción"
                                                    :options="Templates.opcionesTemplates" :allow-empty="false"
                                                    :max-height="150" @input="onSelect">
                                                </multiselect>
                                                <span v-if="validTemplate" class="spanError"
                                                    style="color: red; font-size: 11px">Campo requerido</span>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="6" offset-md="3">
                                                <span style="
                            color: black;
                            text-align: center;
                            font-weight: bold;
                          ">
                                                    Texto a enviar:
                                                </span>
                                            </v-col>
                                            <v-col cols="12" md="6" offset-md="3"
                                                style="justify-content: center; display: flex">
                                                <span style="text-align: center;" class="mt-2">
                                                    {{ this.Templates.ntclave.nttxtwhatsapp }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions class="justify-center">
                                        <v-btn variant="text" color="#536DFE" style="color: white"
                                            @click="EnviarTemplate(Templates.ntclave.ntclave)"
                                            :disabled="botonescargaTemp">Enviar</v-btn>
                                        <v-btn variant="text" @click="CerrarModalTemplate()" color="default"
                                            :disabled="botonescargaTemp">Cerrar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </template>
                        </v-dialog>
                        <v-card class="chatSectionEmpty" v-if="this.cargando == false">
                            <v-card-text style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                                <lottie :options="defaultOptions" :width="500" :height="666"
                                    class="empty-message-animation" />
                                <br /><br />
                                <p class="text-center" style="position: absolute; bottom: 35%">
                                    Haz clic en una conversación para iniciar un chat
                                </p>
                            </v-card-text>
                        </v-card>
                        <v-card v-else class="card-chatSection">
                            <v-card-title v-if="this.Encabezado != []" class="mr-2 card-title-tel">
                                <v-row>
                                    <v-col cols="12" md="5" class="col-tel">
                                        <div class="ml-2 div-ofuscado">
                                            {{ this.Encabezado.telofuscado }}
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="7" class="div-boton-idioma">
                                        <div v-if="this.$store.getters.getChecklistmensajes.length > 0"
                                            class="mr-1 div-vermensajes">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn style="display: flex; align-items: center" v-bind="attrs"
                                                        v-on="on" color="#40C4FF" icon outlined
                                                        @click="ModalObtenerReportes()">
                                                        <v-icon size="28" dark>mdi-tooltip-edit-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Clasificar mensajes</span>
                                            </v-tooltip>
                                        </div>
                                        <div v-if="this.permisovertsms" class="div-vermensajes mr-4" justify="center">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn style="display: flex; align-items: center" v-bind="attrs"
                                                        v-on="on" :color="color" icon outlined
                                                        @click="ObtenerTSMS((vertodossms = !vertodossms))">
                                                        <v-icon size="30" dark>mdi-comment-eye-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ this.mensajeChip }}</span>
                                            </v-tooltip>
                                        </div>
                                        <div v-if="this.Encabezado.WSINGLES" class="div-idioma">
                                            <span>Español -</span>
                                            <v-switch color="success" class="ml-1" inset v-model="idioma"
                                                @change="cambiarIdioma()" false-value="es_MX"
                                                true-value="en_US"></v-switch>
                                            <span style="margin-right: 4vh">- Inglés</span>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text class="conversation-chat-holder chatSection_lottie"
                                v-if="this.cargandolotie == true" style="width: 100%">
                                <lottie :options="defaultOptions2" :width="500" :height="800"
                                    class="empty-message-animation2" />
                            </v-card-text>
                            <v-card-text id="conversation" class="conversation-chat-holder chatSection"
                                v-if="this.cargandolotie == false" style="width: 100%">
                                <div class="old-messages-btn mb-4" v-if="totalMessagesSets > messagePaginationIndex"
                                    @click="getPaginatedMessages()" style="cursor: pointer; margin-top: -10px">
                                    <p class="text-center old-messages-text">
                                        Ver mensajes anteriores
                                    </p>
                                </div>
                                <v-progress-circular :size="100" :width="11" color="#90A4AE" indeterminate
                                    v-if="loadingmenspag" style="left: 45%">
                                </v-progress-circular>
                                <div class="conversation-holder" v-for="(item, index) in $store.state.messagesList"
                                    :key="index">
                                    <MessageBubleLeftVue v-if="item.mwhFromMe == false" :localIndex="index"
                                        @mediaURLEmitWatcher="saveMediaDataOnMessage" :MessageText="item.mwhBody"
                                        :MessageDate="item.mwhFhEnvio" :MessageType="item.mwhMediaContentType"
                                        :MediaURL="item.mwhMediaUrl" :AttachFileName="item.mwhFileName"
                                        :AttachFileFormat="item.mwhFileFormat" :Latitud="item.mwhLatitude"
                                        :Longitud="item.mwhLongitude" :AmazonBackupStatus="item.mwhAmazonS3"
                                        :ReplyId="item.mwhIDReply" :idBubble="item.mwhId"
                                        :FormattedMediaURL="item.formattedUrlMedia" :ntclave="item.ntclave"
                                        :phoneNumber="telefono" :idmwhClave="item.mwhClave"
                                        :mclasificado="item.Clasificado"
                                        :mwhFileCopiedOnReport="item.mwhFileCopiedOnReport"
                                        :mwhEmoji="item.mwhEmoji"
                                        :mwhEmojiAusa="item.mwhEmojiAusa"
                                        @updateEmojie="updateEmojie">
                                    </MessageBubleLeftVue>

                                    <MessageBubleRightVue v-if="item.mwhFromMe == true" :localIndex="index"
                                        @mediaURLEmitWatcher="saveMediaDataOnMessage"
                                        :MessageText="changeLineBreaks(item.mwhBody)" :MessageDate="item.mwhFhEnvio"
                                        :MessageAutor="item.uslogin" :MessageStatus="item.mwhStatus"
                                        :MessageType="item.mwhMediaContentType" :MediaURL="item.mwhMediaUrl"
                                        :AttachFileName="item.mwhFileName" :AttachFileFormat="item.mwhFileFormat"
                                        :AmazonBackupStatus="item.mwhAmazonS3" :ReplyId="item.mwhIDReply"
                                        :idBubble="item.mwhId" :FormattedMediaURL="item.formattedUrlMedia"
                                        :ntclave="item.ntclave" :idmwhClave="item.mwhClave"
                                        :mwhEmoji="item.mwhEmoji"
                                        :mwhEmojiAusa="item.mwhEmojiAusa"
                                        @updateEmojie="updateEmojie"
                                        :phoneNumber="telefono" >
                                    </MessageBubleRightVue>
                                </div>
                                <div v-if="this.Encabezado.EnvioSMS == '0' && this.showsendmsj == true
                                ">
                                    <v-alert type="error" tonal prominent border="left">
                                        No puede enviar mensajes, ya que no se ha recibido respuesta en menos de 24
                                        horas,
                                        solo puede enviar templates <v-icon>mdi-forum</v-icon> y una vez que tenga
                                        respuesta se reactivará la
                                        conversación.
                                    </v-alert>
                                </div>
                            </v-card-text>
                            <v-card-actions v-if="showsendmsj">
                                <v-row>
                                    <v-col cols="12" md="9" sm="9">
                                        <v-textarea class="mt-3" placeholder="Escribe algo ..." rows="2" no-resize
                                            outlined filled v-model="mensajeTexto" :readonly="envioMultimedia" clearable
                                            @keydown="EnterEvent($event)" :required="valtextarea"
                                            :error-messages="textval" :disabled="validacionbotones"
                                            maxlength="200"></v-textarea>
                                    </v-col>
                                    <v-col cols="12" md="3" sm="3" style="display: flex; align-items: center">
                                        <v-row>
                                            <v-col cols="3" md="3" sm="3" style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        ">
                                                <v-btn :disabled="validacionbotones" icon style="align-self: center"
                                                    v-if="envioMultimedia == false">
                                                    <v-icon class="btns" dark
                                                        @click="EnviarMensaje(mensajeTexto.trim())">mdi-send</v-icon>
                                                </v-btn>
                                                <v-btn icon style="align-self: center" :disabled="validacionbotones"
                                                    v-else>
                                                    <v-icon class="btns" dark
                                                        @click="EnviarMultimedia()">mdi-send</v-icon>
                                                </v-btn>
                                            </v-col>
                                            <!--Cambio Yair-->
                                            <v-col cols="3" md="3" sm="3" style="
                                                  display: flex;
                                                  justify-content: center;
                                                  align-items: center;">

                                                <v-speed-dial v-model="fab2" direction="top" :open-on-hover="false"
                                                    :transition="transition" style="align-self: center">
                                                    <template v-slot:activator>
                                                        <v-btn v-model="fab2" icon id="multimedia2">
                                                            <v-icon class="btns" v-if="fab2">mdi-close</v-icon>
                                                            <v-icon class="btns" v-else>mdi-forum</v-icon>
                                                        </v-btn>
                                                    </template>

                                                    <v-btn dark small @click="ObtenerTemplate(0)" color="#01579B">
                                                        Template
                                                        <v-icon>mdi-file-document</v-icon>
                                                    </v-btn>
                                                    <v-btn dark small @click="ObtenerTemplate(1)" color="#00ACC1"
                                                        v-if="permisoTemplateCalidad && validacionTemplateCalidad">
                                                        Template Calidad
                                                        <v-icon>mdi-clipboard-check</v-icon>
                                                    </v-btn>
                                                </v-speed-dial>
                                            </v-col>
                                            <!------>
                                            <v-col cols="3" md="3" sm="3" style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        ">
                                                <v-btn icon :disabled="validacionbotones">
                                                    <v-icon class="btns"
                                                        @click="showEmoji = !showEmoji">mdi-emoticon</v-icon>
                                                </v-btn>
                                                <div v-if="showEmoji"
                                                    style="position: absolute; right: 1%; bottom: 18%">
                                                    <VEmojiPicker @select="selectEmoji" />
                                                </div>
                                            </v-col>
                                            <v-col cols="3" md="3" sm="3" style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        ">
                                                <v-speed-dial v-model="fab" direction="top" :open-on-hover="false"
                                                    :transition="transition" style="align-self: center">
                                                    <template v-slot:activator>
                                                        <v-btn v-model="fab" icon id="multimedia"
                                                            :disabled="validacionbotones">
                                                            <v-icon class="btns" v-if="fab">mdi-close</v-icon>
                                                            <v-icon class="btns" v-else>mdi-paperclip</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <input type="file"
                                                        accept="audio/aac, audio/mp4, audio/mpeg, audio/amr, audio/ogg"
                                                        ref="fileAudio" @change="onFileChanged" style="display: none" />
                                                    <v-btn @click="Archivoclick('fileAudio')" fab dark small
                                                        color="#80CBC4">
                                                        <v-icon>mdi-music</v-icon>
                                                    </v-btn>
                                                    <input type="file"
                                                        accept="image/jpeg, image/png,video/mp4, video/3gp"
                                                        ref="fileImgVideo" @change="onFileChanged"
                                                        style="display: none" />
                                                    <v-btn @click="Archivoclick('fileImgVideo')" fab dark small
                                                        color="#00ACC1">
                                                        <v-icon>mdi-image</v-icon>
                                                    </v-btn>
                                                    <input type="file"
                                                        accept="text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                        ref="fileDoc" @change="onFileChanged" style="display: none" />
                                                    <v-btn @click="Archivoclick('fileDoc')" fab dark small
                                                        color="#01579B">
                                                        <v-icon>mdi-file-document</v-icon>
                                                    </v-btn>
                                                </v-speed-dial>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-actions>
                        </v-card>
                    </v-container>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import animationData from "@/assets/animations/84745-message.json";
import WhatsappService from "@/services/Whatsapp/Whatsapp.service.js";
import lottie from "lottie-web";
import inicio from "@/assets/animations/84745-message.json";
import Telefonos from "@/components/pages/Whatsapp/TelefonosWhatsapp.vue";
import animationLoading from "@/assets/animations/loadingws.json";
import MessageBubleLeftVue from "@/components/pages/Whatsapp/MessageBuble-Left.vue";
import MessageBubleRightVue from "@/components/pages/Whatsapp/MessageBuble-Right.vue";
import { parsePhoneNumber } from "awesome-phonenumber";
import { VEmojiPicker } from "v-emoji-picker";

export default {
    title() {
        return this.$route.meta.title
    },
    created: function () {
        this.$socket.start({
            // Logging is optional but very helpful during development
        });
        let self = this;
        this.$socket.on("ReceiveMessage", (message) => {
            if (this.$route.name == "Whatsapp") {
                self.newMessage(message, 0);
            }
        });
        this.$socket.on("ReceiveMessageNew", (message) => {
            if (this.$route.name == "Whatsapp") {
                self.newMessage(message, 1);
            }
        });
        this.$socket.on("UpdateStatus", (message) => {
            if (this.$route.name == "Whatsapp") {
                if (message != undefined) {
                    self.newStatusUpdate(message);
                }
            }
        });
        this.$socket.on("UpdateEmojie", (message) => {
            if (this.$route.name == "Whatsapp") {
                if (message != undefined) {
                    self.newStatusEmojie(message);
                }
            }
        });
        this.$socket.on("ReceiveMessageTemplate", (message) => {
            if (this.$route.name == "Whatsapp") {
                self.newMessage(message, 0);
            }
        });
    },
    sockets: {
        ReceiveMessage(message, newTel) {
            //console.log("Recibi algo")// From what i've read this has to be here or the events wont fire
        },
        ReceiveMessageTemplate(message) { },
        ReceiveMessageNew(message) { },
        UpdateStatus(message) {
            // From what i've read this has to be here or the events wont fire
        },
        UpdateEmojie(message) {
            // From what i've read this has to be here or the events wont fire
        },
        WspLeido(message) {
            //console.log("");
        },
    },
    components: {
        Telefonos,
        MessageBubleLeftVue,
        MessageBubleRightVue,
        VEmojiPicker,
    },
    data: function () {
        return {
            busquedaTel: null,
            defaultOptions: {
                animationData: animationData,
            },
            cargando: false,
            telefono: [],
            defaultOptions: {
                animationData: inicio,
                loop: "true",
                autoPlay: "true",
                speed: "1",
            },
            defaultOptions2: {
                animationData: animationLoading,
                loop: "true",
                autoPlay: "true",
                speed: "1",
            },
            cargarChat: false,
            ayuda: false,
            switch2: true,
            cargandolotie: false,
            Encabezado: [],
            msjList: [],
            idioma: null,
            listenerEmoji: false,
            mensajeTexto: "",
            transition: "slide-y-reverse-transition",
            fab: false,

            archivo: "",
            envioMultimedia: false,
            typefile: 0,
            lastIndex: null,
            listaTemporal: [],
            //paginacion
            messagePaginationIndex: 1,
            totalMessagesSets: 0,
            totalMessagesCount: 0,
            loadingmenspag: false,
            //val de textarea
            showsendmsj: false,
            valtextarea: false,
            textval: null,
            showEmoji: false,
            pastScrollHeightRef: "",
            permisovertsms: false,
            vertodossms: false,
            nrreporte: 0,
            svindice: 0,
            color: "default",
            mensajeChip: "Ver todos los mensajes",
            dialog: false,
            validareporte: false,
            Reportes: {
                opcionesReportes: [],
                nrreporte: 0,
                svindice: 0,
                Reporte: "",
            },
            dialogTemplates: false,
            Templates: {
                opcionesTemplates: [],
                ntclave: 0,
                nttxtwhatsapp: "",
                ntproceso: "",
            },
            permisoEnvioMensaje: false,
            permisoNoRegistraLectura: false,
            cargar: false,
            cargarTemplate: false,
            botonescarga: false,
            validTemplate: false,
            botonescargaTemp: false,
            validacionbotones: false,
            fab2: false,
            datos: {},
            permisoTemplateCalidad: false,
            validacionTemplateCalidad: false
        };
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    watch: {
        mensajeTexto(val) {
            if (val == null) {
                this.envioMultimedia = false;
                this.mensajeTexto = "";
            } else {
                this.valtextarea = false;
                this.textval = null;
            }
        },
        "Reportes.nrreporte"(val) {
            this.validareporte = false;
        },
    },
    methods: {
        onSelect() {
            this.validTemplate = false;
        },
        selectEmoji(emoji) {
            this.mensajeTexto = this.mensajeTexto + emoji.data;
            this.showEmoji = false;
        },
        scrollToBottomAuto() {
            var element = document.getElementById("conversation");
            element.scrollTop = element.scrollHeight;
        },
        formatNumber(number) {
            const pn = parsePhoneNumber(number);
            let formatted = pn.getNumber("international");
            return formatted;
        },
        async ObtenerTemplatesWS(tipo) {
            let respuestaTemp = await WhatsappService.TemplatesWS(this, this.Encabezado.stadescripcion, this.datos, tipo);
            this.Templates.opcionesTemplates = respuestaTemp;
        },
        async ValidarTemplateCalidad() {
            let respuestaTemp = await WhatsappService.ValidarTemplateCalidad(this, this.Encabezado.stadescripcion);
            this.validacionTemplateCalidad = respuestaTemp == 1 ? true : false;
        },

        async ObtenerEncabezado(numero) {
            this.Encabezado = [];
            this.idioma = null;
            let respuesta = await WhatsappService.ObtenerEncabezado(this, numero, this.datos);
            if (respuesta != null) {
                let auxEncabezado = await respuesta[0];
                for (const [key, value] of Object.entries(auxEncabezado)) {
                    if (typeof value == "object") {
                        auxEncabezado[key] = "";
                    } else if (key == "WSINGLES" || key == "selected" || key == "twhAutorizaEnvioNotificacion" || key == "twhTerminado") {
                        //auxEncabezado[key] = auxEncabezado[key].toLowerCase() === 'true';
                    } else {
                        auxEncabezado[key] = value.toString();
                    }
                }
                this.Encabezado = auxEncabezado;
                this.idioma = this.Encabezado.twhLanguage;
                if (
                    this.permisoEnvioMensaje == true &&
                    this.Encabezado.twhAutorizaEnvioNotificacion == "1" &&
                    this.telefono.Eliminado == "0"
                ) {
                    this.showsendmsj = true;
                } else {
                    this.showsendmsj = false;
                }
                this.validacionbotones = this.Encabezado.EnvioSMS == "0" ? true : false;
                await MetodosGenerales.verificarPermisoSolo(
                    this.domain.domainNameForApi,
                    "VerificarPermiso",
                    "356"
                ).then((response) => {
                    if (response.data.length > 0) {
                        this.permisovertsms = true;
                    }
                });
            } else {
                this.Encabezado = [];
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error",
                    text: "Ocurrió un error al intentar obtener información de la conversación, inténtelo más tarde.",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            }
        },
        async ChatSeleccionadoEmit(item) {
            this.cargandolotie = true;
            this.vertodossms = false;
            this.$store.commit("emptyMessageList");
            this.$store.commit("limpiarlistacheck");
            this.msjList = [];
            this.telefono = item;
            this.color = "#455A64";
            this.permisovertsms = false;
            this.cargando = true;
            this.Encabezado = [];
            this.idioma = null;
            this.showsendmsj = false;
            this.nrreporte = this.datos.nrreporte;
            this.svindice = this.datos.svindice;
            await this.getLastMessages(this.telefono.twhTelefono);
            await this.ObtenerEncabezado(this.telefono.twhTelefono);
            this.Encabezado.stadescripcion = item.stadescripcion;

            let listaTemporal = await this.$store.state.listaTerminada;
            let index = await listaTemporal.findIndex((tel) => {
                return tel.twhTelefono == this.telefono.twhTelefono;
            });

            await this.ValidarTemplateCalidad();
            if (index < 0) {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Oops...',
                    text: 'Ocurrió un error inesperado al cargar los mensajes, por favor recargue la página e intente nuevamente, si el error persiste contacte a soporte',
                    allowOutsideClick: false,
                    showConfirmButton: true,
                    confirmButtonText: "Recargar",
                }).then((res) => {
                    if (res.isConfirmed) {
                        window.location.reload();
                    }
                });
            } else {
                listaTemporal[index].twhNotificacionPendiente = (this.permisoNoRegistraLectura && listaTemporal[index].twhNotificacionPendiente==1) ? 1 : 0;
                this.$store.commit("changePropListaTerminada", listaTemporal);
                this.cargandolotie = false;
                setTimeout(() => {
                    this.scrollToBottomAuto();
                }, 400)
                if (
                    this.permisoEnvioMensaje == true &&
                    this.Encabezado.twhAutorizaEnvioNotificacion == "1" &&
                    this.telefono.Eliminado == "0"
                ) {
                    this.showsendmsj = true;
                } else {
                    this.showsendmsj = false;
                }
            }



        },
        async ObtenerMensajes(number) {
            this.msjList = await WhatsappService.ObtenerMsjs(
                this,
                number,
                this.nrreporte,
                this.svindice,
                !this.permisoNoRegistraLectura
            );
            if (this.msjList != null) {
                this.$store.commit("fillListaMensajes", this.msjList);
                if (this.msjList.length > 0) {
                    this.pastScrollHeightRef = this.msjList[0].mwhClave;
                    //this.pastScrollHeightRef = this.msjList[0].mwhClave;
                    this.lastIndex = this.msjList[this.msjList.length - 1].mwhClave;
                   
                    let lectura = await WhatsappService.RegistrarLectura(
                        this,
                        this.telefono.twhTelefono,
                        this.msjList[0].mwhClave,
                        this.msjList[this.msjList.length - 1].mwhClave,
                        this.nrreporte,
                        this.svindice
                    );
                    if (lectura == null) {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: "Ocurrió un error, inténtelo más tarde.",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        });
                    }
                }
            } else {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error",
                    text: "No se pudo obtener los mensajes de esta conversación, inténtelo más tarde.",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            }
        },
        async cambiarIdioma() {
            let respuesta = await WhatsappService.CambiarIdioma(
                this,
                this.Encabezado.twhTelefono,
                this.idioma
            );
            if (respuesta == null) {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error",
                    text: "No se pudo cambiar el idioma, inténtelo más tarde.",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            }
        },
        async EnviarTemplate(ntclave) {
            if (this.Templates.ntclave == 0) {
                this.validTemplate = true;
                return;
            }
            this.botonescargaTemp = true;
            this.cargarTemplate = true;
            let error = await WhatsappService.TemplateConversacion(
                this,
                this.Encabezado.stnumero, ntclave, this.datos
            );
            this.cargarTemplate = false;
            if (error == false) {
                this.$swal({
                    position: "center",
                    icon: "success",
                    title: "Correcto!",
                    text: "Se ha enviado el mensaje correctamente.",
                    timer: 4000,
                    showConfirmButton: true,
                }).then((result) => {
                    this.dialogTemplates = false;
                    this.Templates.ntclave = 0;
                });
            } else {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Oops...",
                    text: "Ocurrió un error inesperado al enviar el mensaje, inténtelo nuevamente.",
                    timer: 3000,
                    showConfirmButton: true,
                }).then((result) => {
                    this.dialogTemplates = false;
                    this.Templates.ntclave = 0;
                });
            }
            this.botonescargaTemp = false;
        },
        async ObtenerTemplate(tipo) {
            this.dialogTemplates = true;
            //this.Templates.ntclave = null;
            this.ObtenerTemplatesWS(tipo);
            //let respuesta = await WhatsappService.TemplateConversacion(
            //    this,
            //    this.Encabezado.twhTelefono
            //);
        },
        async CerrarModalTemplate() {
            this.dialogTemplates = false;
            this.Templates.ntclave = 0;
            this.validTemplate = false;
        },
        changeLineBreaks(text) {
            return text.replace("\\r\\n", "<br>");
        },
        async EnviarMensaje(mensaje) {
            if (mensaje.length > 0) {
                this.valtextarea = false;
                this.mensajeTexto = "";
                this.textval = null;
                let formattedNumber = this.formatNumber(this.Encabezado.twhTelefono);
                formattedNumber = formattedNumber.replace(/ /g, "");
                formattedNumber = formattedNumber.replace("+", "");
                let number = this.Encabezado.twhTelefono;
                number = number.replace("+", "");
                let respuesta = await WhatsappService.EnviarMensaje(
                    this,
                    mensaje,
                    number,
                    formattedNumber,
                    this.datos
                );
                if (respuesta == null) {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Error",
                        text: "No se pudo enviar el mensaje, inténtelo más tarde.",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    });
                } else {
                    await this.obtenerNuevosMensajes("+" + number);
                }
                this.scrollToBottomAuto();
            } else {
                this.valtextarea = true;
                this.textval = "Este campo es requerido";
            }
        },
        Archivoclick(tipo) {
            switch (tipo) {
                case "fileAudio":
                    this.$refs.fileAudio.click();
                    document.getElementById("multimedia").click();
                    this.typefile = 3;
                    break;
                case "fileImgVideo":
                    this.$refs.fileImgVideo.click();
                    document.getElementById("multimedia").click();
                    this.typefile = 1;
                    break;
                case "fileDoc":
                    this.$refs.fileDoc.click();
                    document.getElementById("multimedia").click();
                    this.typefile = 2;
                    break;
            }
        },
        onFileChanged(e) {
            this.envioMultimedia = true;
            this.mensajeTexto = "";
            this.archivo = "";
            this.mensajeTexto = e.target.files[0].name;
            this.archivo = e.target.files[0];
        },
        async saveMediaDataOnMessage(index, newMediaURL) {
            let auxMessageList = this.$store.getters.getMessagesList;

            let auxData = auxMessageList[index];
            auxData.formattedUrlMedia = newMediaURL;
            //this.$store.commit("changePropMessageList", auxData, index);
            this.$store.commit("changePropMessageList", {
                auxData,
                index,
            });
        },
        async EnviarMultimedia() {
            this.mensajeTexto = "";
            let formattedNumber = this.formatNumber(this.Encabezado.twhTelefono);
            formattedNumber = formattedNumber.replace(/ /g, "");
            formattedNumber = formattedNumber.replace("+", "");
            let number = this.Encabezado.twhTelefono;
            number = number.replace("+", "");
            let respuesta = await WhatsappService.EnviarMultimedia(
                this,
                number,
                formattedNumber,
                this.archivo,
                this.typefile,
                this.datos
            );
            if (respuesta == null) {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error",
                    text: "No se pudo enviar el mensaje, inténtelo más tarde.",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            } else {
                await this.obtenerNuevosMensajes("+" + number);
            }
            this.scrollToBottomAuto();
            this.archivo = "";
            this.envioMultimedia = false;
        },
        async newMessage(number, isNew) {
            this.listaTemporal = [];
            if (this.Encabezado.twhTelefono == number) {
                await this.ObtenerEncabezado(number);
                await this.obtenerNuevosMensajes(number);
            } else {
                let listaTemporal = await this.$store.state.listaTerminada;

                let index = await listaTemporal.findIndex((tel) => {
                    return tel.twhTelefono == number;
                });

                if (index != -1 && index != undefined) {
                    listaTemporal[index].twhNotificacionPendiente = 1;
                    let tempElement = listaTemporal[index];
                    listaTemporal.splice(index, 1);
                    listaTemporal.unshift(tempElement);
                    this.$store.commit("changePropListaTerminada", listaTemporal);
                }
            }
            this.validacionbotones = this.Encabezado.EnvioSMS == "0" ? true : false;
        },
        async obtenerNuevosMensajes(number) {


            let response = await WhatsappService.ObtenerMensajesNuevos(
                this,
                number,
                this.lastIndex,
                this.nrreporte,
                this.svindice,
                !this.permisoNoRegistraLectura
            );
            if (response != null) {
                this.lastIndex = response[response.length - 1].mwhClave;

                let auxMessages = response;
                auxMessages.forEach((element) => {
                    const idExists = this.$store.getters.getMessagesList.some((item) => item.mwhClave == element.mwhClave);
                    if (!idExists) {
                        this.$store.commit("addMessageToMessageList", element);
                    }
                });
                
                    await WhatsappService.RegistrarMsjLeido(this, number, this.lastIndex);
            } else {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error",
                    text: "Ocurrió un error al obtener los nuevos mensajes, inténtelo más tarde.",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            }

            this.scrollToBottomAuto();
        },
        async newStatusUpdate(messageId) {
            if (this.$store.state.messagesList != null) {
                let response = await WhatsappService.ObtenerNuevoEstatusMensaje(
                    this,
                    messageId
                );

                if (response[0] != undefined) {
                    let tempclave = response[0];

                    if (tempclave.mwhTo == this.Encabezado.twhTelefono) {
                        //let auxmessagelist = this.$store.state.messagesList;
                        let auxmessagelist = this.$store.getters.getMessagesList;

                        var index = await auxmessagelist.findIndex(
                            (item) => item.mwhClave == tempclave.mwhClave
                        );

                        if (index != -1 && index != undefined) {
                            var tempmessagedata = this.$store.state.messagesList[index];
                            tempmessagedata.mwhStatus = tempclave.mwhStatus;

                            //this.$store.commit("changePropMessageList", tempmessagedata, index);
                            // this.$store.commit("changepropmessagelist", tempmessagedata, index);
                        }
                    }
                }
            }
        },
        async newStatusEmojie(messageId) {
            if (this.$store.state.messagesList != null) {
                let response = await WhatsappService.ObtenerNuevoEmojie(
                    this,
                    messageId
                );


                if (response[0] != undefined) {
                    let tempclave = response[0];

                    if (tempclave.mwhTo == this.Encabezado.twhTelefono || tempclave.mwhFrom == this.Encabezado.twhTelefono) {
                        //let auxmessagelist = this.$store.state.messagesList;
                        let auxmessagelist = this.$store.getters.getMessagesList;

                        var index = await auxmessagelist.findIndex(
                            (item) => item.mwhClave == tempclave.mwhClave
                        );
                        if (index != -1 && index != undefined) {
                            var tempmessagedata = this.$store.state.messagesList[index];
                            tempmessagedata.mwhEmoji = tempclave.mwhEmoji;

                            //this.$store.commit("changePropMessageList", tempmessagedata, index);
                            // this.$store.commit("changepropmessagelist", tempmessagedata, index);
                        }
                    }
                }
            }
        },
        async updateEmojie(emojie, mwhclave) {
            if (this.$store.state.messagesList != null) {
                let auxmessagelist = this.$store.getters.getMessagesList;
                var index = await auxmessagelist.findIndex(
                    (item) => item.mwhClave == mwhclave
                );
                if (index != -1 && index != undefined) {
                    var tempMessageData = this.$store.state.messagesList[index];
                    tempMessageData.mwhEmojiAusa = emojie;
                }
            }
            
        },
        async getPaginatedMessages() {
            this.loadingmenspag = true;
            let auxMessageList = this.$store.getters.getMessagesList;
            this.$store.commit("emptyMessageList");
            this.messagePaginationIndex = this.messagePaginationIndex + 1;
            //Recupera los 20 mensajes anteriores al index
            let response = await WhatsappService.ObtenerMensajesPaginados(
                this,
                this.Encabezado.twhTelefono,
                this.messagePaginationIndex,
                this.nrreporte,
                this.svindice
            );
            if (response != null) {
                let auxMessageListNew = await response.concat(auxMessageList);
                await this.$store.commit("replaceListaMensajes", auxMessageListNew);
                var index = await this.msjList.length;
                this.loadingmenspag = false;
                let lectura = WhatsappService.RegistrarLectura(
                    this,
                    this.Encabezado.twhTelefono,
                    response[0].mwhClave,
                    response[response.length - 1].mwhClave,
                    this.nrreporte,
                    this.svindice
                );
                if (lectura == null) {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Error",
                        text: "Ocurrió un error, inténtelo más tarde.",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    });
                }
                this.scrollToScrollRef();
                this.pastScrollHeightRef = response[0].mwhClave;
            } else {
                this.loadingmenspag = false;
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error",
                    text: "Ocurrió un error al obtener los mensajes de la conversación, inténtelo más tarde.",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            }
        },
        async getLastMessages(number) {
            this.messagePaginationIndex = 1;
            this.totalMessagesCount = 0;
            this.totalMessagesSets = 0;
            let totalMsjResponse = await WhatsappService.ObtenerTotalMensajes(
                this,
                number,
                this.nrreporte,
                this.svindice
            );
            this.totalMessagesCount = totalMsjResponse.mensajesCount;
            this.totalMessagesSets = Math.ceil(this.totalMessagesCount / 20);
            await this.ObtenerMensajes(number);
        },
        EnterEvent: function (event) {
            if (event.keyCode === 13 && !event.shiftKey) {
                event.preventDefault();
                if (this.envioMultimedia == false) {
                    this.EnviarMensaje(this.mensajeTexto.trim());
                } else {
                    this.EnviarMultimedia();
                }
            }
            if (
                event.keyCode === 13 &&
                event.shiftKey &&
                this.envioMultimedia == false
            ) {
                event.preventDefault();
                this.mensajeTexto = this.mensajeTexto + "\n";
            }
        },
        async scrollToScrollRef() {
            let formatId = this.pastScrollHeightRef;
            setTimeout(function () {
                var scrollElement = document.getElementById(formatId);
                if (scrollElement != null) {
                    scrollElement.scrollIntoView();
                }
            }, 500);
        },
        async ObtenerTSMS() {
            this.showsendmsj = false;
            this.$store.commit("emptyMessageList");
            this.msjList = [];
            this.cargandolotie = true;
            if (this.vertodossms == true) {
                this.color = "#2979FF";
                this.mensajeChip = "Ver mensajes por reporte ";
                this.nrreporte = null;
                this.svindice = null;
            } else {
                this.color = "#455A64";
                this.mensajeChip = "Ver todos los mensajes";

                this.nrreporte = this.datos.nrreporte;
                this.svindice = this.datos.svindice;
            }
            await this.getLastMessages(this.telefono.twhTelefono);
            this.cargandolotie = false;
            setTimeout(() => {
                this.scrollToBottomAuto();
                if (
                    this.permisoEnvioMensaje == true &&
                    this.Encabezado.twhAutorizaEnvioNotificacion == "1" &&
                    this.telefono.Eliminado == "0"
                ) {
                    this.showsendmsj = true;
                } else {
                    this.showsendmsj = false;
                }
            }, 100)
        },
        async ModalObtenerReportes() {
            this.dialog = true;
            this.Reportes.Reporte = "";
            this.Reportes.nrreporte = 0;
            this.validareporte = false;
            if (this.telefono.stadescripcion == 'Abogado' || this.telefono.stadescripcion == 'Supervisor') {

                await WhatsappService.ObtenerReportes(this, null, this.datos.nrreporte, this.datos.svindice);
            } else {
                await WhatsappService.ObtenerReportes(this, this.Encabezado.twhTelefono, null, null);
            }
        },
        async ClasificarMensajes() {
            if (this.Reportes.nrreporte != "") {
                this.cargar = true;
                this.botonescarga = true;
                let resp = await WhatsappService.ClasificarMensajes(
                    this,
                    this.Reportes.nrreporte.nrreporte,
                    this.Reportes.nrreporte.svindice,
                    this.Encabezado.twhTelefono,
                    this.$store.getters.getChecklistmensajes
                );
                if (resp.length == 0) {
                    this.$store.getters.getChecklistmensajes.forEach((id) => {
                        var index = this.$store.state.messagesList.findIndex(
                            (obj) => obj.mwhClave === id
                        );
                        if (index > -1) {
                            this.$store.state.messagesList[index].Clasificado = 1;
                        }
                    });
                    this.cargar = false;
                    this.botonescarga = false;
                    this.dialog = false;
                    this.$store.commit("limpiarlistacheck");
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Éxito",
                        text: "Se clasificaron los mensajes con éxito",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    });
                } else {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Error",
                        text: "Ocurrió un error al categorizar los mensajes, inténtelo más tarde.",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    });
                }
            } else {
                this.validareporte = true;
            }
        },
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.nrreporte = this.datos.nrreporte;
        this.svindice = this.datos.svindice;
        let permisoEnvio = await MetodosGenerales.verificarPermisoSolo(
            this.domain.domainNameForApi,
            "VerificarPermiso",
            "363"
        );
        let permisoNoRegistro = await MetodosGenerales.verificarPermisoSolo(
            this.domain.domainNameForApi,
            "VerificarPermiso",
            "381"
        );
        this.permisoNoRegistraLectura = permisoNoRegistro.data.length == 0 ? false : true;
        this.permisoEnvioMensaje = permisoEnvio.data == 0 ? false : true;
        let permisoTemCalid = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "380");
        this.permisoTemplateCalidad = permisoTemCalid.data == 0 ? false : true;
    },
};
</script>
<style>
.dialog-reporte {
    margin-left: 25px;
    margin-right: 25px;
    max-width: 800px;

    margin-top: 25px;
    margin-left: 25px;
    max-height: 800px;
}

.multiselect {
    width: 100%;
}
</style>
<style scoped>
.chatSection_lottie {
    background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
    background-repeat: repeat;
    width: 98%;
    height: 90% !important;
}

.chatSection {
    background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
    background-repeat: repeat;
    min-height: 580px !important;
    height: 70vh;
    width: 98%;
    overflow-y: scroll !important;
    display: flex !important;
    flex-direction: column !important;
}

.chatSectionEmpty {
    background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
    background-repeat: repeat;
    min-height: 580px !important;
    height: 90vh !important;
    border-color: #6c757d;
    border-style: solid solid solid solid;
    border-width: 1px;
    width: 98%;
    margin-left: 10px;
}

.empty-message-animation {
    max-width: 50%;
    margin-left: auto;
    margin-right: auto;
    top: -20%;
    position: absolute;
}

.empty-message-animation2 {
    max-width: 50%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
}

.card .chatSection {
    min-height: 600px !important;
    max-height: 700px !important;
    flex-direction: column-reverse !important;
    border-color: #6c757d;
    border-style: solid solid solid solid;
    border-width: 1px;
    overflow-y: scroll !important;
    overflow-x: hidden;
    height: inherit;
}

.conversation-chat-holder::-webkit-scrollbar {
    width: 5px;
}

.conversation-chat-holder::-webkit-scrollbar-track {
    background: transparent;
}

.conversation-chat-holder::-webkit-scrollbar-thumb {
    background: #c3c1bb;
}

.conversation-chat-holder::-webkit-scrollbar-thumb:hover {
    background: #5c5b59;
}

.old-messages-btn {
    background-color: rgba(241, 241, 241, 0.6);
    padding-top: 10px;
    padding-bottom: 10px;
}

.old-messages-text {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 800;
    word-spacing: 3px;
    font-size: 14px;
    color: black;
}

.cel {
    font-size: 1.3em;
    background-image: linear-gradient(rgb(60, 212, 160), rgb(60, 212, 160));
    background-size: 100% 3px;
    background-repeat: no-repeat;
    background-position: 100% 100%;
}

.btns {
    font-size: 32px !important;
}

.container-chat {
    height: 90vh;
    margin-bottom: 1%;
}

@media screen and (max-height: 662px) {
    .chatSection {
        background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
        background-repeat: repeat;
        min-height: 300px !important;
        height: 50vh;
        overflow-y: scroll !important;
    }

    .btns {
        font-size: 28px !important;
    }
}

@media screen and (max-height: 718px) and (min-height: 604px) {
    .chatSection {
        background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
        background-repeat: repeat;
        min-height: 350px !important;
        height: 55vh;
        overflow-y: scroll !important;
    }

    .btns {
        font-size: 28px !important;
    }
}

@media screen and (max-height: 719px) and (min-height: 664px) {
    .chatSection {
        background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
        background-repeat: repeat;
        min-height: 100px !important;
        overflow-y: scroll !important;
    }

    .btns {
        font-size: 28px !important;
    }
}

@media screen and (max-height: 730px) and (min-height: 720px) {
    .chatSection {
        background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
        background-repeat: repeat;
        min-height: 440px !important;
        height: 55vh;
        overflow-y: scroll !important;
    }

    .btns {
        font-size: 28px !important;
    }
}

@media screen and (max-height: 780px) and (min-height: 731px) {
    .chatSection {
        background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
        background-repeat: repeat;
        min-height: 400px !important;
        height: 60vh;
        overflow-y: scroll !important;
    }

    .btns {
        font-size: 28px !important;
    }
}

@media screen and (max-height: 949px) and (min-height: 780px) {
    .chatSection {
        background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
        background-repeat: repeat;
        min-height: 420px !important;
        height: 65vh;
        overflow-y: scroll !important;
    }

    .btns {
        font-size: 26px !important;
    }
}

/* @media screen and (max-height: 1090px) and (min-height: 950px) {
    .chatSection {
        background-image: url("https://www.ausa.com.mx/img/bg-whatsapp.png");
        background-repeat: repeat;
        min-height: 450px !important;
        height: 70vh;
        overflow-y: scroll !important;
    }

    .btns {
        font-size: 28px !important;
    }
} */

@media screen and (max-width: 958px) {
    .conversation-chat-holder {
        overflow-y: scroll;
    }

    .btns {
        font-size: 26px !important;
    }

    .container-chat {
        height: 100%;
        margin-bottom: 1%;
    }

    .chatSectionEmpty {
        height: 100% !important;
    }

    .card-chatSection {
        height: 100% !important;
    }

    .col-tel {
        justify-content: center;
        align-items: center;
    }

    .div-ofuscado {
        font-size: 24px;
        font-weight: 600;
        letter-spacing: 3px;
        margin-top: 5%;
    }

    .div-idioma {
        display: flex;
        justify-content: center !important;
        align-items: center;
        font-size: 1rem;
    }
}

@media screen and (max-width: 767px) {
    .div-boton-idioma {
        display: flex;
        align-content: center;
        justify-content: center;
    }
}

@media screen and (min-width: 768px) {
    .div-boton-idioma {
        display: flex;
        align-content: end;
        justify-content: end;
    }
}

.card-chatSection {
    height: 90vh;
}

.col-tel {
    display: flex;
    align-items: center;
}

.card-title-tel {
    margin-top: -15px;
    width: 100%;
    border-bottom: solid #546e7a;
}

.div-ofuscado {
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 3px;
}

.div-idioma {
    display: flex;
    justify-content: end;
    align-items: center;
    font-size: 1rem;
}

.div-vermensajes {
    display: flex;
    justify-content: end;
    align-items: center;
}


.multiselect {
    width: 100%;
}
</style>